import React from 'react';
import { Link } from 'react-router-dom';

export const getColumns = (reembolsos) => {
  const asistencias = [...new Set(reembolsos.map((r) => r.asistenciaID).filter(Boolean))]
    .map((v) => ({ text: v, value: v }));

  return [
    {
      title: 'ID',
      dataIndex: 'reembolsoID',
      key: 'reembolsoID',
      align: 'center',
      sorter: (a, b) => a.reembolsoID - b.reembolsoID,
      render: (id) => <Link to={`/reembolsos/detalle/${id}`}>{id}</Link>,
    },
    {
      title: 'Asistencia',
      dataIndex: 'asistenciaID',
      key: 'asistenciaID',
      align: 'center',
      filters: asistencias,
      filterSearch: true,
      onFilter: (value, r) => r.asistenciaID === value,
    },
    {
      title: 'Monto',
      dataIndex: 'monto',
      key: 'monto',
      align: 'center',
      sorter: (a, b) => a.monto - b.monto,
      render: (v) => `$${Number(v).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`,
    },
    {
      title: 'Fecha',
      dataIndex: 'fechaCreacion',
      key: 'fechaCreacion',
      align: 'center',
      sorter: (a, b) => new Date(a.fechaCreacion) - new Date(b.fechaCreacion),
      defaultSortOrder: 'descend',
      render: (v) => v?.slice(0, 10),
    },
  ];
};